<template>
    <div class="topcontainer">
        <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-8 rounded formatleft" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="300">
                <div v-html="aboutgovern.sec1" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="300">

                </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-4 formatright" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="300" >
                <div class="card movetop shadow-lg text-dark bg-light mb-3" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="300">
                    <div class="card-body" v-html="aboutgovern.seconeright" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="300" :class="{rightdivclass: rightdivtheme === 'rightdivclass'}"> 
                    </div>
                  </div>
            </div>
        </div>
    </div>
     

</template>


<script>
export default {
    props: ['aboutgovern', 'dataleftdivtheme', 'rightdivtheme'],
}
</script>

<style scoped>
.movetop {
    margin-top: -100px;
}

.formatleft, .formatright {
    font-size: 16px;
    text-align: left;
}
.card {
    padding: 30px;
}
/*===================MEDIA SCREENS TAMPLATES===============*/
 /* Extra small devices (phones, 600px and down) */
 @media only screen and (max-width: 600px) {

    .formatright {
        margin-top: 100px;
        padding: 40px;
    }
   .formatleft {
    padding: 40px;
   }   
   .topcontainer {
    margin-top: 30px;
    text-align: left;
   } 
   .topcontainer {
    padding-left: 20px;
    padding-right: 20px;
}
 }

 /* Small devices (portrait tablets and large phones, 600px and up) */
 @media only screen and (min-width: 600px) {

    .formatright {
        margin-top: 100px;
        padding: 40px;
        text-align: justify;
    }
   .formatleft {
    padding: 40px;
    text-align: justify;
   }   
   .topcontainer {
    margin-top: 30px;
    text-align: left;
   } 
   .topcontainer {
    padding-left: 40px;
    padding-right: 40px;
}

 }
 /* Medium devices (landscape tablets, 768px and up) */
 @media only screen and (min-width: 768px) {

    .formatright {
        margin-top: 100px;
        padding: 40px;
        text-align: justify;
        width: 100%;
    }
   .formatleft {
    padding: 40px;
    text-align: justify;
    width: 100%;
   }   
   .topcontainer {
    margin-top: 30px;
    text-align: left;
   } 
   .topcontainer {
    padding-left: 20px;
    padding-right: 20px;
}
 }
 
 /* Large devices (laptops/desktops, 992px and up) */
 @media only screen and (min-width: 992px) {

   .formatleft {
    padding: 40px;
    text-align: justify;
    width: 60%;
   } 
   .formatright {
    margin-top: 100px;
    padding: 40px;
    text-align: justify;
    width: 40%;
}
.topcontainer {
    padding-left: 40px;
    padding-right: 40px;
}

 }
 

 @media screen and (min-width: 1024px) {

 

 }
 /* Extra large devices (large laptops and desktops, 1200px and up) */
 @media only screen and (min-width: 1200px) {

    .formatright {
        margin-top: -100px;
       }
    .formatleft {
    font-size: 16px;
    text-align: left;
    padding-left: 120px;
    padding-right: 120px;
    }
 } 
</style>
